module.exports = __webpack_public_path__ + "pc/img/img_award2023_03.5bde654b.png";